import axios from "axios";
axios.defaults.headers.common["Request-Type"] = "ajax";
// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么;
    let { errcode } = response.data || {};
    if (errcode === 401) {
      let {
        data: { authorizeURI },
      } = response.data;
      let currentURI = location.href;
      currentURI = encodeURIComponent(currentURI);
      currentURI = encodeURIComponent(currentURI);
      let redirectURI = authorizeURI;
      redirectURI = redirectURI.replace("REDIRECT_URI", currentURI);

      location.replace(redirectURI);
    }

    return response;
  },
  (error) => {
    // console.log(error);
    return Promise.reject(error);
  }
);
export default axios;
